import { get, sumBy } from 'lodash'

export const priceOfReservation = reservation => get(reservation, 'order_item.item_price', 0)
export const priceOfReservations = reservations => sumBy(reservations, priceOfReservation)
